export const ESTIMATE_CHAT_KEYS = {
  all: () => ["estimateChat"] as const,
  chats: (estimateId: string) => [...ESTIMATE_CHAT_KEYS.all(), "chats", estimateId] as const,
  messages: (estimateId: string, chatId: string) => [...ESTIMATE_CHAT_KEYS.all(), "messages", estimateId, chatId] as const,
};
